/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Setting_QInputs */



/**
* | output |
* | --- |
* | "Where is this event played?" |
*
* @param {Tournament_Wiz_Setting_QInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_setting_q = /** @type {((inputs?: Tournament_Wiz_Setting_QInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Setting_QInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Où se joue cet événement ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Dónde se juega este evento?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Onde este evento é jogado?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dove si gioca questo evento?")
	return /** @type {LocalizedString} */ ("Where is this event played?")
});